(function (angular) {
	'use strict';

	angular
		.module('modalModule', [
			'BaseConfig'
		])
		.constant('DISCLAIMER_MAP', {
			'ach-maximum-exceeded' : '/static/html/shared/disclaimers/ach-maximum-exceeded.html',
			'comparative-projected-performance-assumptions' : '/static/html/shared/disclaimers/comparative-projected-performance-assumptions.html',
			'comparative-yield-assumptions' : '/static/html/shared/disclaimers/comparative-yield-assumptions.html',
			'cumulative-total-originations' : '/static/html/shared/disclaimers/cumulative-total-originations.html',
			'daily-liquidity-cost' : '/static/html/shared/disclaimers/daily-liquidity-cost.html',
			'designed-to-outperform-portfolio' : '/static/html/shared/disclaimers/designed-to-outperform-portfolio.html',
			'drip-performance-chart' : '/static/html/shared/disclaimers/drip-performance-chart.html',
			'investment-goal-create' : '/static/html/shared/disclaimers/investment-goal-create.html',
			'investment-goal-dashboard' : '/static/html/shared/disclaimers/investment-goal-dashboard.html',
			'investment-goal-invest' : '/static/html/shared/disclaimers/investment-goal-invest.html',
			'historical-performance-assumptions' : '/static/html/shared/disclaimers/historical-performance-assumptions.html',
			'historical-reit-performance-chart' : '/static/html/shared/disclaimers/historical-reit-performance-chart.html',
			'invalid-plaid-account-selected' : '/static/html/shared/disclaimers/invalid-plaid-account-selected.html',
			'ipo-shareholdings-value' : '/static/html/shared/disclaimers/ipo-shareholdings-value.html',
			'link-bank-account-manually' : '/static/html/shared/disclaimers/link-bank-account-manually.html',
			'mtc-disclaimer' : '/static/html/shared/disclaimers/mtc-disclaimer.html',
			'opportunity-fund-how-it-works' : '/static/html/shared/disclaimers/opportunity-fund-how-it-works.html',
			'opportunity-fund-introducing' : '/static/html/shared/disclaimers/opportunity-fund-introducing.html',
			'opportunity-fund-tax-calculator' : '/static/html/shared/disclaimers/opportunity-fund-tax-calculator.html',
			're-average-dividend-yield-chart' : '/static/html/shared/disclaimers/re-average-dividend-yield-chart.html',
			'real-estate-vs-inflation-chart' : '/static/html/shared/disclaimers/real-estate-vs-inflation-chart.html',
			'recurring-performance-chart' : '/static/html/shared/disclaimers/recurring-performance-chart.html',
			'redemption-discount-schedule' : '/static/html/shared/disclaimers/redemption-discount-schedule.html',
			'reviews-assumptions' : '/static/html/shared/disclaimers/reviews-assumptions.html'
		});
})(window.angular);